// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rnyc","clinicsSelect":"styles_clinicsSelect__2UATM"};